module.exports = __webpack_public_path__ + "static/media/kok.e05b3717.jpg";